// Auto-generated by app/scripts/generate.ts — do not edit
import { definePackageEntry } from '@tinycld/core/lib/packages/config-types'
import { lazy } from 'react'
import { registerCollections as calcRegister } from '@tinycld/calc/collections'
import type { CalcSchema } from '@tinycld/calc/types'
import calcAutomation from '@tinycld/calc/automation'
import { registerCollections as calendarRegister } from '@tinycld/calendar/collections'
import type { CalendarSchema } from '@tinycld/calendar/types'
import calendarAutomation from '@tinycld/calendar/automation'
import { registerCollections as contactsRegister } from '@tinycld/contacts/collections'
import type { ContactsSchema } from '@tinycld/contacts/types'
import contactsAutomation from '@tinycld/contacts/automation'
import { registerCollections as driveRegister } from '@tinycld/drive/collections'
import type { DriveSchema } from '@tinycld/drive/types'
import driveAutomation from '@tinycld/drive/automation'
import { registerCollections as mailRegister } from '@tinycld/mail/collections'
import type { MailSchema } from '@tinycld/mail/types'
import mailAutomation from '@tinycld/mail/automation'
import { registerCollections as textRegister } from '@tinycld/text/collections'
import type { TextSchema } from '@tinycld/text/types'
import textAutomation from '@tinycld/text/automation'

export const tinycldConfig = [
    definePackageEntry<CalcSchema>()({
        manifest: { ...({"name":"Calc","slug":"calc","version":"0.4.1","description":"Collaborative spreadsheets for your server","nav":{"label":"Calc","icon":"table","order":20,"shortcut":"s"},"routes":{"directory":"screens"},"repository":{"url":"https://github.com/tinycld/calc"},"dependencies":["drive"]} as const), packageName: "@tinycld/calc" },
        registerCollections: calcRegister,
        provider: { load: () => import('@tinycld/calc/provider') },
        automation: calcAutomation,
    }),
    definePackageEntry<CalendarSchema>()({
        manifest: { ...({"name":"Calendar","slug":"calendar","version":"0.4.0","description":"Shared calendars, events and reminders","nav":{"label":"Calendar","icon":"calendar","order":8,"shortcut":"c"},"routes":{"directory":"screens"},"repository":{"url":"https://github.com/tinycld/calendar"}} as const), packageName: "@tinycld/calendar" },
        registerCollections: calendarRegister,
        sidebar: lazy(() => import('@tinycld/calendar/sidebar')),
        provider: { load: () => import('@tinycld/calendar/provider') },
        automation: calendarAutomation,
    }),
    definePackageEntry<ContactsSchema>()({
        manifest: { ...({"name":"Contacts","slug":"contacts","version":"0.3.0","description":"Your personal contacts, private to you","nav":{"label":"Contacts","icon":"users","order":10,"shortcut":"o"},"routes":{"directory":"screens"},"repository":{"url":"https://github.com/tinycld/contacts"}} as const), packageName: "@tinycld/contacts" },
        registerCollections: contactsRegister,
        sidebar: lazy(() => import('@tinycld/contacts/sidebar')),
        search: {
            load: (): Promise<unknown> => import('@tinycld/contacts/search-adapter'),
        },
        automation: contactsAutomation,
    }),
    definePackageEntry<DriveSchema>()({
        manifest: { ...({"name":"Drive","slug":"drive","version":"0.4.0","description":"Cloud file storage, with WebDAV","nav":{"label":"Drive","icon":"hard-drive","order":12,"shortcut":"d"},"routes":{"directory":"screens"},"publicRoutes":{"directory":"public-screens"},"repository":{"url":"https://github.com/tinycld/drive"}} as const), packageName: "@tinycld/drive" },
        registerCollections: driveRegister,
        sidebar: lazy(() => import('@tinycld/drive/sidebar')),
        provider: { load: () => import('@tinycld/drive/provider') },
        search: {
            load: (): Promise<unknown> => import('@tinycld/drive/search-adapter'),
        },
        automation: driveAutomation,
    }),
    definePackageEntry<Record<string, never>>()({
        manifest: { ...({"name":"Google Takeout Import","slug":"google-takeout-import","version":"0.3.0","description":"Import data from Google Takeout .zip files.","repository":{"url":"https://github.com/tinycld/google-takeout-import"}} as const), packageName: "@tinycld/google-takeout-import" },
        settings: [
            { slug: "google-takeout", label: "Import from Google", Component: lazy(() => import('@tinycld/google-takeout-import/settings/takeout')) },
        ],
    }),
    definePackageEntry<MailSchema>()({
        manifest: { ...({"name":"Mail","slug":"mail","version":"0.6.0","description":"Gmail-style email for your server","nav":{"label":"Mail","icon":"mail","order":5,"shortcut":"m"},"routes":{"directory":"screens"},"repository":{"url":"https://github.com/tinycld/mail"}} as const), packageName: "@tinycld/mail" },
        registerCollections: mailRegister,
        sidebar: lazy(() => import('@tinycld/mail/sidebar')),
        settings: [
            { slug: "provider", label: "Domains", Component: lazy(() => import('@tinycld/mail/settings/provider')) },
            { slug: "mailboxes", label: "Mailboxes", Component: lazy(() => import('@tinycld/mail/settings/mailboxes')) },
        ],
        systemSettings: [
            { slug: "provider", label: "Provider", keyPrefix: "mail.", Component: lazy(() => import('@tinycld/mail/system-settings/provider')) },
        ],
        search: {
            load: (): Promise<unknown> => import('@tinycld/mail/search-adapter'),
        },
        setupSteps: [
            { id: "email-domain", label: "Email domain", order: "a2V", load: (): Promise<unknown> => import('@tinycld/mail/setup/EmailDomainStep') },
            { id: "address", label: "Your address", order: "a2k", load: (): Promise<unknown> => import('@tinycld/mail/setup/AddressStep') },
        ],
        automation: mailAutomation,
    }),
    definePackageEntry<TextSchema>()({
        manifest: { ...({"name":"Text","slug":"text","version":"0.4.0","description":"Plain-text and rich-text documents.","nav":{"label":"Text","icon":"file-text","order":15,"shortcut":"t"},"routes":{"directory":"screens"},"repository":{"url":"https://github.com/tinycld/text"},"dependencies":["drive"]} as const), packageName: "@tinycld/text" },
        registerCollections: textRegister,
        provider: { load: () => import('@tinycld/text/provider') },
        automation: textAutomation,
    }),
] as const

export type MergedPackageSchema = CalcSchema & CalendarSchema & ContactsSchema & DriveSchema & MailSchema & TextSchema
